import { useEffect, useState } from 'react';

/**
 * Hook to "initialize" API config
 * 
 * With the new simplified apiConfig.ts, there's nothing to preload.
 * This hook exists for backward compatibility - it always succeeds instantly.
 */
export const useApiConfigInit = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error] = useState<Error | null>(null);

  useEffect(() => {
    // Nothing to load - config is inline
    setIsLoading(false);
  }, []);

  return { isLoading, error };
};

export default useApiConfigInit;